import { render, staticRenderFns } from "./ProjectTabOverview.vue?vue&type=template&id=ca43b072&scoped=true"
import script from "./ProjectTabOverview.vue?vue&type=script&lang=ts"
export * from "./ProjectTabOverview.vue?vue&type=script&lang=ts"
import style0 from "./ProjectTabOverview.vue?vue&type=style&index=0&id=ca43b072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca43b072",
  null
  
)

export default component.exports